import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

import { MenuCustomerComponent } from '../menu-customer/menu-customer.component';

@Component({
	selector: 'app-mobile-header-customer',
	imports: [MenuCustomerComponent, RouterLink],
	templateUrl: './mobile-header-customer.component.html',
	styleUrl: './mobile-header-customer.component.scss',
})
export class MobileHeaderCustomerComponent {}
